

































































































































































































































































































import { Component, Emit, Prop, Ref, Vue } from "vue-property-decorator";
import { Choice } from "@/api/model/Choice";
import { FactorGroup, FactorResource } from "@/api/model/FactorResource";
import QuestionnaireFactorValueInput from "@/components/choice-input/questionnaire/QuestionnaireFactorValueInput.vue";
import QuestionnaireGrowingTableInput from "@/components/choice-input/questionnaire/QuestionnaireGrowingTableInput.vue";
import QuestionnaireFixedTableInput from "@/components/choice-input/questionnaire/QuestionnaireFixedTableInput.vue";
import ImagePicker from "@/components/common/ImagePicker.vue";
import QuestionnaireFactorNavigationPanel
    from "@/components/choice-input/questionnaire/QuestionnaireFactorNavigationPanel.vue";

@Component(
    {
        components: {
            QuestionnaireFactorNavigationPanel,
            ImagePicker,
            QuestionnaireFixedTableInput,
            QuestionnaireGrowingTableInput,
            QuestionnaireFactorValueInput
        }
    })
export default class QuestionnaireChoiceInput extends Vue {

    @Prop()
    name!: string;

    @Prop()
    description!: string;

    @Prop()
    choice!: Choice;

    @Prop()
    modelFactorResources!: { [id: string]: FactorResource };

    @Prop({
        type: Object,
        default: () => ({})
    })
    styles!: any;

    @Prop()
    submitting!: boolean;

    @Prop()
    disabled!: boolean;

    @Ref('informationForm')
    private informationForm: HTMLFormElement

    private step = 0;

    private submitted = false;

    get questionFactors() {
        return this.getQuestionFactorsSubSet('M');
    }

    get isDisabled(): boolean {
        return !this.choice.name || false;
    }

    get currentFactorId() {
        if (this.step > 0 && this.questionFactors) {
            if (this.questionFactors[this.step - 1]) {
                return this.questionFactors[this.step - 1].id
            }
        }
        return null;
    }

    getQuestionFactorsSubSet(groupId: string) {
        let subQuestionFactorList: any[] = [];
        let factorGroup: FactorGroup = this.modelFactorResources[groupId] as FactorGroup;
        let children = factorGroup.childrenIds.map(id => this.modelFactorResources[id])
            .filter(f => f && f.numWeightingDots || 0 > 0);

        children.forEach((child: FactorResource) => {
            if (child.type === 'FACTOR_GROUP' && (!(child as FactorGroup).groupTypeDefinition || !(child as FactorGroup).groupTypeDefinition.type.startsWith('TABLE'))) {
                subQuestionFactorList = subQuestionFactorList.concat(this.getQuestionFactorsSubSet(child.id))
            } else {
                subQuestionFactorList.push(child)
            }
        });
        return subQuestionFactorList;
    }

    private start() {
        if (!this.informationForm.validate()) return;
        this.step++;
    }

    @Emit()
    private submit() {
        this.submitted = true;
    }

    private stepForm(val: string) {
        const questions = this.questionFactors;
        if (val && questions) {
            const questionIndex: number = questions.findIndex((value) => value.id === val);
            this.step = questionIndex + 1;
        }
    }

    private findParent(searchId: string, currentId: string, factorResources: { [id: string]: FactorResource }): FactorGroup | undefined {
        let factorResource = factorResources[currentId];
        if (factorResource.type === 'FACTOR_GROUP') {
            if ((factorResource as FactorGroup).childrenIds.includes(searchId)) {
                return factorResources[currentId] as FactorGroup
            }
            for (let childId of (factorResource as FactorGroup).childrenIds) {
                let subsearch = this.findParent(searchId, childId, factorResources);
                if (subsearch) {
                    return subsearch
                }
            }
        }
    }

    private rules = {
        required: (value: string) => !!value || 'Required'
    };


}
